import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CaseStudyDetail from "@/pages/CaseStudyDetail";

const supportedLanguages = ["en", "es", "fr", "de", "pt", "ar", "ja", "hi", "zh", "he"];

const validCaseStudyIds = [
  "healthcare-clinic",
  "ecommerce-shopify",
  "hotel-hospitality",
  "real-estate",
  "insurance-finance",
  "restaurant-group",
  "law-firm",
  "saas-tech",
  "auto-dealership",
  "home-services",
];

export function LocalizedCaseStudyWrapper() {
  const { lang, id } = useParams<{ lang: string; id: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem("i18nextLng", lang);
    }
  }, [lang, i18n]);

  // If language is not supported, redirect to English version
  if (!lang || !supportedLanguages.includes(lang)) {
    return <Navigate to={`/en/case-studies/${id}`} replace />;
  }

  // If id doesn't match any case study, redirect to case studies index
  if (!id || !validCaseStudyIds.includes(id)) {
    return <Navigate to="/case-studies" replace />;
  }

  return <CaseStudyDetail />;
}

export { supportedLanguages, validCaseStudyIds };
